import { Outlet, useParams } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { TwoColumnLayout } from '@factorialco/factorial-one-react'
import { AtsCandidateDetailDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { CandidateSideContent } from './SideContent'

const CandidateDetailPage = () => {
  const { id } = useParams()
  const { company } = useCurrentSession()
  const { loading, data } = useQuery(AtsCandidateDetailDocument, {
    variables: { id: Number(id), companyId: company.id },
  })

  const candidate = data?.ats.candidate

  if (loading || !candidate) {
    return (
      <Box padding="s40" alignItems="center">
        <Spinner />
      </Box>
    )
  }

  return (
    <TwoColumnLayout sideContent={<CandidateSideContent data={candidate} />}>
      <Box flexGrow height="full" overflowY="auto">
        <Outlet context={{ candidate }} />
      </Box>
    </TwoColumnLayout>
  )
}

export default CandidateDetailPage
